import React, { useState } from "react";
import companyLogo from "../assets/aei-logo.jpg";
import { registerRequest } from "../api/auth";

function RegisterPage({ onBackToLogin }) {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");

  const [statusMessage, setStatusMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage("");
    setError("");

    const normalizedEmail = String(email || "").trim().toLowerCase();
    const allowedDomain = "@aeiprogetti.it";

    if (!normalizedEmail.endsWith(allowedDomain)) {
      setError(`Please use your company email (${allowedDomain}).`);
      return;
    }

    setLoading(true);

    try {
   const res = await registerRequest({
  email: normalizedEmail,
});

      setStatusMessage(
        res?.message || "Registration submitted. Waiting for admin approval."
      );
      setEmail("");
      setUsername("");
    } catch (err) {
      setError(
        err?.response?.data?.message || "Registration is not available yet."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-layout">
      <header className="app-header">
        <div className="app-header-left">
          <img
            src={companyLogo}
            alt="AEI Progetti"
            className="app-header-logo-small"
            width="140"
            height="50"
          />
          <div>
            <div className="app-header-company">AEI PROGETTI SRL</div>
            <div className="app-header-tagline">Engineering Software Suite</div>
          </div>
        </div>
      </header>

      <main className="auth-page">
        <div className="auth-card">
          <div className="auth-logo">
            <img src={companyLogo} alt="AEI Progetti" width="140" height="50" />
          </div>

          <h1 className="auth-title">Register</h1>
          <p className="auth-subtitle">Create your AEI account.</p>

          {error && <div className="status-message">{error}</div>}
          {statusMessage && (
            <div className="status-message-success">{statusMessage}</div>
          )}

          <form onSubmit={handleSubmit} className="auth-form">
           

            <div className="form-field">
              <label className="form-label" htmlFor="reg-email">
                Email
              </label>
              <input
                id="reg-email"
                className="form-input"
                type="email"
                value={email}
                onChange={(e) => {
                  const val = e.target.value;
                  setEmail(val);
                  setUsername(
                    String(val || "")
                      .split("@")[0]
                      .toLowerCase()
                      .replace(/[^a-z0-9._-]/g, "")
                  );
                }}
                required
                pattern="^[^@\s]+@aeiprogetti\.it$"
                title="Use your company email (example@aeiprogetti.it)"
                placeholder="your.name@aeiprogetti.it"
              />
            </div>

            <div className="form-field">
              <label className="form-label" htmlFor="reg-username">
                Username
              </label>
              <input
                id="reg-username"
                className="form-input"
                type="text"
                value={username}
                readOnly
              />
            </div>

            <button
              type="submit"
              className="primary-button"
              disabled={loading}
            >
              {loading ? "Registering..." : "Register"}
            </button>
          </form>

          <div className="auth-footer">
            <span>Already have an account?</span>
            <button
              type="button"
              className="link-button"
              onClick={onBackToLogin}
            >
              Back to Login
            </button>
          </div>
        </div>
      </main>

      <footer className="site-footer">
        <div className="site-footer-inner">
          <div className="site-footer-section site-footer-logo">
            <img src={companyLogo} alt="AEI Progetti" />
            <div>
              <strong>AEI PROGETTI SRL</strong>
              <br />
              Via Bolognese 48
              <br />
              50139 Firenze, Italy
            </div>
          </div>

          <div className="site-footer-section">
            <div>Phone: +39 055 400714</div>
            <div>Fax: +39 055 461079</div>
          </div>

          <div className="site-footer-section">
            <div>Email: mail@aeiprogetti.it</div>
            <div>PEC: mail@pec.aeiprogetti.it</div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default RegisterPage;